import React, { useState } from 'react';
import LoadingModal from '../Components/AllModal/LoadingModal';
import * as XLSX from 'xlsx';
import { userPool } from '../utils/aws';
import { CognitoUserAttribute } from 'amazon-cognito-identity-js';
import toastMessage from '../utils/toastMessage';
// import { confirmUserEmail } from '../utils/AWS/confirmEmail';
import { Table } from 'antd';

const columns = [
  {
    title: 'Name',
    dataIndex: 'Name',
    key: 'Name',
    // render: (date) => <p className='text-sm font-sans '>{date.toLocaleDateString('en-US', { month: 'short', day: '2-digit' })}</p>,
  },
  {
    title: 'Email',
    dataIndex: 'Email',
    key: 'Email',
    // render: (description) => (<p className='text-sm font-sans '>{description}</p>),
  },
  {
    title: 'Phone',
    dataIndex: 'Phone',
    key: 'Phone',
    // render: (description) => (<p className='text-sm font-sans '>{description}</p>),
  },
  {
    title: 'Password',
    dataIndex: 'Password',
    key: 'Password',
    // render: (type) => (<p className='text-sm font-sans '>{type}</p>),
  },
];

function ExcelReader() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleCreateAccount = async (name, email, phone, password) => {
    let attributeList = [
      new CognitoUserAttribute({ Name: "name", Value: name }),
      new CognitoUserAttribute({ Name: "email", Value: email }),
      new CognitoUserAttribute({
        Name: "phone_number",
        Value: phone.toString().includes("+") ? phone.toString() : `+${phone}`,
      }),
    ];

    setLoading(true);
    userPool.signUp(
      email,
      password,
      attributeList,
      null,
      function (err, result) {
        if (err) {
          console.log(err);
          toastMessage(err.message, "error");
          setLoading(false);
          return;
        }
        var cognitoUser = result.user;
        console.log(cognitoUser, "cognitoUser");
        console.log("user name is " + cognitoUser.getUsername());
        toastMessage("Successfully Signup", "success");
        setLoading(false);
      }
    );
  };

  const delay = (duration) => new Promise(resolve => setTimeout(resolve, duration));

  const handleFile = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    
    reader.onload = async (event) => {
      // Parse data
      const bstr = event.target.result;
      const workbook = XLSX.read(bstr, {type:'binary'});
      
      // Get first worksheet
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      
      // Convert to array of objects
      const data = XLSX.utils.sheet_to_json(worksheet);
      setItems(data);
      // for (let i = 0; i < data.length; i++) {
      //   const user = data[i];
      //   if(!user.Name || !user.Email || !user.Phone || !user.Password){
      //     toastMessage(`Please Provide valid data at row ${i+1}`);
      //     continue;
      //   }
        // await handleCreateAccount(user.Name, user.Email, user.Phone, user.Password);
        // await confirmUserEmail(user.Email);
        // await delay(5000)
      // }
      console.log(data);
    };
    
    reader.readAsBinaryString(file);
  }


  return (
    <div>
      {loading && <LoadingModal className="bg-gray-500/80" />}
      <input type="file" accept=".xlsx, .xls" onChange={handleFile} />
      <div>
        <Table columns={columns} dataSource={items} />
      </div>
    </div>
  );
}

export default ExcelReader;
